<template>
    <div>
        <consultoria
            :consultoria="consultoria"
            v-show="mostrarConsultoria"
            :solicitacao="false"
            :services="obterServices()"
            :fornecedor="false"
            @obterConsultoriaAtualizada="obterConsultoriaAtualizada()"
        >
            <template slot="footer">
                <app-btn-voltar></app-btn-voltar>
            </template>
        </consultoria>
    </div>
</template>

<script>
import ConsultoriasServicos from './ConsultoriasServicos'
import Consultoria from '../../componentes/consultorias/Consultoria'

export default {
    data() {
        return {
            consultoria: {}
        }
    },

    methods: {
        obterServices() {
            return ConsultoriasServicos
        },

        obterConsultoria() {
            this.$store.dispatch('addRequest')
            ConsultoriasServicos.obterConsultoriaPorId(
                this.$route.params.consultoriaId
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.consultoria = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter consultoria!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterConsultoriaAtualizada() {
            this.obterConsultoria()
            this.$store.dispatch('setRecarregar', true)
        }
    },

    computed: {
        mostrarConsultoria() {
            return (
                this.$route.name ==
                'AppSebrae_Consultorias_Uabs_Consultorias_Detalhar'
            )
        }
    },

    mounted() {
        this.obterConsultoria()
    },

    components: {
        Consultoria
    }
}
</script>
